import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { SettingsHeader } from '../Settings';
import './../Setting.scss';
import SDK from '../../../SDK';
import { getLocalUserId, formatUserIdToJid } from '../../../../Helpers/Chat/User';
import { CHAT_TYPE_SINGLE } from '../../../../Helpers/Chat/Constant';
import {
    getDisappearOptionLabelKey,
    optionToMsgDisappear,
    msgDisappearToOption,
} from '../../../../Helpers/Chat/disappearOptions';
import { i18n } from '../../../../localization/i18n';

// This screen lists Off last; labels come from the shared option list.
const OPTION_IDS = ['24hours', '7days', '90days', 'Off'];

const DisappearingMessages = ({ handleBackToSetting }) => {
    // Own user's vCardData is updated by userProfileListener (vcard API) — correct source.
    // Roster IQ carries msgDisappear = 0 incorrectly, so we intentionally read from vCardData only.
    const vCardData = useSelector(state => state.vCardData);

    const [selectedOption, setSelectedOption] = useState(() => msgDisappearToOption(vCardData?.data?.msgDisappear));

    // Real-time: react when userProfileListener fires and updates vCardData
    useEffect(() => {
        if (vCardData?.data?.msgDisappear !== undefined) {
            setSelectedOption(msgDisappearToOption(vCardData.data.msgDisappear));
        }
    }, [vCardData?.id]);

    const handleOptionSelect = async id => {
        setSelectedOption(id);
        const numericValue = optionToMsgDisappear(id);
        // Persist immediately so resolveDisappearAt can read it after a page refresh even
        // if the server profile response (getUserProfile) doesn't return msgDisappear.
        try {
            localStorage.setItem('_daz_own_msg_disappear', String(numericValue));
        } catch (_) {}
        const ownJid = formatUserIdToJid(getLocalUserId());
        if (ownJid) {
            await SDK.setChatMessageDisappear(ownJid, numericValue, CHAT_TYPE_SINGLE);
        }
    };

    return (
        <div className="setting-container disappearing-messages-container">
            <div className="settinglist">
                <SettingsHeader label={'Disappearing Messages'} handleBackFromSetting={handleBackToSetting} />

                <div className="disappearing-content">
                    <p className="disappearing-description">Start new chats with a disappearing message timer set to</p>

                    <div className="radio-group-container">
                        {OPTION_IDS.map(optionId => (
                            <div
                                key={optionId}
                                className="radio-option-row"
                                onClick={() => handleOptionSelect(optionId)}
                            >
                                <div className={`custom-radio ${selectedOption === optionId ? 'selected' : ''}`}>
                                    {selectedOption === optionId && <div className="radio-dot"></div>}
                                </div>
                                <span className="radio-label">{i18n.t(getDisappearOptionLabelKey(optionId))}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

DisappearingMessages.propTypes = {
    handleBackToSetting: PropTypes.func.isRequired,
};

export default DisappearingMessages;
